import React from 'react';
import styles from './NavigationCard.module.scss';
import Text from '../Text/Text';

interface Props {
	icon: string;
	title: string;
	subtitle?: string;
	onClick: () => void;
}

const NavigationCard: React.FC<Props> = ({
	icon,
	onClick,
	title,
	subtitle,
}) => {
	return (
		<div className={styles.wrapper} onClick={onClick}>
			<div className={styles.iconWrapper}>
				<img src={icon} alt='icon' />
			</div>
			<div>
				<Text tx={title} className={styles.title} />
				{subtitle && <Text tx={subtitle} className={styles.text} />}
			</div>
		</div>
	);
};

export default NavigationCard;
